import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Dropdown, Form, Badge } from "react-bootstrap";
import { FaUserSecret, FaExchangeAlt } from "react-icons/fa";
import { userService } from "../../services/user.service";
import { userActions } from "../../actions/user.actions";

function ImpersonationMenu({ user }) {
  const dispatch = useDispatch();
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user.isSuperUser && user.clientId) {
      loadUsers();
    }
    // eslint-disable-next-line
  }, [user.clientId]);

  const loadUsers = async () => {
    setLoading(true);
    try {
      const response = await userService.get({
        clientId: user.clientId,
        clientGuid: user.clientGuid,
      });
      // Response has paginated structure: { data: [], pageNumber, totalPages, etc }
      setUsers(response.data?.data || []);
    } catch (error) {
      setUsers([]);
    } finally {
      setLoading(false);
    }
  };

  const handleImpersonate = (targetUserId) => {
    dispatch(userActions.impersonate(targetUserId));
  };

  const handleStopImpersonation = () => {
    dispatch(userActions.stopImpersonation(
      user.originalUserId,
      user.originalClientId,
      user.originalClientGuid,
      user.originalClientName
    ));
  };

  // Show if user is super user OR if currently impersonating (to allow exit)
  if (!user.isSuperUser && !user.isImpersonating) {
    return null;
  }

  const filteredUsers = users.filter(
    (u) =>
      u.userId !== user.userId &&
      (u.firstName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        u.lastName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        u.email?.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  return (
    <Dropdown align="end">
      <Dropdown.Toggle variant={user.isImpersonating ? "warning" : "outline-secondary"} size="sm">
        <FaUserSecret className="me-2 mb-1" />
        {user.isImpersonating ? "Impersonating" : "Impersonate"}
      </Dropdown.Toggle>
      <Dropdown.Menu className="p-2" style={{ minWidth: "300px" }}>
        {user.isImpersonating ? (
          <>
            <div className="p-2 bg-warning bg-opacity-10 rounded mb-2">
              <small className="text-muted d-block">Currently impersonating:</small>
              <strong>{user.firstName} {user.lastName}</strong>
              <br />
              <small className="text-muted">{user.email}</small>
            </div>
            <Dropdown.Item onClick={handleStopImpersonation}>
              <FaExchangeAlt className="me-2" />
              Exit Impersonation
            </Dropdown.Item>
          </>
        ) : (
          <>
            <Form.Control
              type="text"
              placeholder="Search users..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              size="sm"
              className="mb-2"
              autoFocus
            />
            {loading && (
              <div className="text-center text-muted p-2">
                <small>Loading users...</small>
              </div>
            )}
            {!loading && filteredUsers.length === 0 && (
              <div className="text-center text-muted p-2">
                <small>No users found</small>
              </div>
            )}
            <div style={{ maxHeight: "300px", overflowY: "auto" }}>
              {filteredUsers.map((u) => (
                <Dropdown.Item
                  key={u.userId}
                  onClick={() => handleImpersonate(u.userId)}
                >
                  <div>
                    <strong>{u.firstName} {u.lastName}</strong>
                    {u.isAdmin && (
                      <Badge bg="primary" className="ms-2" size="sm">
                        Admin
                      </Badge>
                    )}
                    <br />
                    <small className="text-muted">{u.email}</small>
                  </div>
                </Dropdown.Item>
              ))}
            </div>
          </>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default ImpersonationMenu;
